import {
  AutocompleteArrayInput,
  Datagrid,
  EditButton,
  List,
  ReferenceArrayField,
  ReferenceArrayInput,
  required,
  SearchInput,
  SimpleForm,
} from 'react-admin';
import { IfCanAccess } from '@react-admin/ra-rbac';
import React from 'react';
import { LIST_DEBOUNCE } from '../../../config';
import { EditWithSuccess } from '../../../components/baseForms/EditWithSuccess';
import { CreateWithSuccess } from '../../../components/baseForms/CreateWithSuccess';
import CustomBulkActionButtons from '../../../components/buttons/CustomBulkActionButtons';
import { exporter } from '../../../utils/customExporter';
import { DateFieldWithTime } from '../../../components/fields/DateFieldWithTime';
import { MultipleChipInput } from '../../../components/inputs/MultipleChipInput';
import SimpleChipListField from '../../../components/fields/SimpleChipListField';

const transform = (data: any) => {

  return {
    ...data,
    customers: data.customers.map((customer: any) => ({
      _id: customer,
      _ref: 'Customer',
    })),
  };

};
export const DomainLinkList = () => {

  const domainFilters = [
    <SearchInput source="q" alwaysOn sx={{
      '& .MuiFilledInput-input': {
        height: '31px',
      },
      width: '100%',
    }} variant="filled"/>,
  ];
  return (
    <List filters={domainFilters} debounce={LIST_DEBOUNCE} title="resources.domainlinks.title" exporter={exporter}>
      <Datagrid rowClick="toggleSelection" bulkActionButtons={<CustomBulkActionButtons/>}>
        <SimpleChipListField source="domains" label="resources.domainlink.fields.domain" />
        <ReferenceArrayField source="customers" reference="customers" label="resources.alarms.fields.customer._id" />
        <DateFieldWithTime source="createdAt" label="general.fields.createdAt" timeOnHover={true}/>
        <DateFieldWithTime source="updatedAt" label="general.fields.updatedAt" timeOnHover={true}/>
        <IfCanAccess action="edit">
          <EditButton/>
        </IfCanAccess>
      </Datagrid>
    </List>
  );

};

export const DomainLinkEdit = () => {

  return (
    <EditWithSuccess title="resources.domainlinks.title" actions={false} transform={transform}>
      <SimpleForm>
        <ReferenceArrayInput source="customers" reference="customers" >
          <AutocompleteArrayInput label="resources.alarms.fields.customer._id" fullWidth/>
        </ReferenceArrayInput>
        <MultipleChipInput source="domains" label="resources.domainlink.fields.domain" validate={required()} />
      </SimpleForm>
    </EditWithSuccess>
  );

};

export const DomainLinkCreate = () => {

  return (
    <CreateWithSuccess title="resources.domainlinks.title" transform={transform}>
      <SimpleForm>
        <ReferenceArrayInput source="customers" reference="customers" >
          <AutocompleteArrayInput label="resources.alarms.fields.customer._id" fullWidth/>
        </ReferenceArrayInput>
        <MultipleChipInput source="domains" label="resources.domainlink.fields.domain" validate={required()} />
      </SimpleForm>
    </CreateWithSuccess>
  );

};
